export default class Referrals
{
    static save(ref) {
        if (ref) {
            window.sessionStorage.setItem('referral', ref);
        }
    }

    static get() {
        return window.sessionStorage.getItem('referral');
    }

    static remove() {
        return window.sessionStorage.removeItem('referral');
    }
}
